import { render, staticRenderFns } from "./success.vue?vue&type=template&id=1668b305&scoped=true&"
import script from "./success.vue?vue&type=script&lang=ts&"
export * from "./success.vue?vue&type=script&lang=ts&"
import style0 from "./success.vue?vue&type=style&index=0&id=1668b305&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1668b305",
  null
  
)

export default component.exports